'use strict';

angular.module('adf')
.service('metricService', function($http) {
	return {
		getSelectedMetric: function(metrics, metricId, crossSiteName) {
			var selectedMetric = null;
			jQuery.each(metrics, function() {
				if (this.ndx === metricId) {
					selectedMetric = this;
					// break out of each()
					return false;
				}
			});
			if (selectedMetric === null) {
				jQuery.each(metrics, function() {
					if (this.crossSiteName === crossSiteName) {
						selectedMetric = this;
						return false;
					}
				});
			}
			return selectedMetric;
		},
		updateAxis: function(axisObj, metricNdx) {
			var url = '/api/2/factndx/' + globalConfig.factory.id + '/MetricAxis/' + metricNdx;
			$http.put(url, axisObj)
				.then(function(data, status, headers, config) {

				})
				.catch(function(data, status, headers, config) {

				});
		}
	};
});
